<template>
  <component v-if="template" :is="template" :info />
</template>

<script setup>
import { getGoogleTemplatesInfo } from "@/api/google";
import { isInPWA, isInAndroidApp } from "@/env";
const info = ref(null);
const template = shallowRef(null);
const id = useRoute().query.tid;

const templates = {
  GoogleStore: defineAsyncComponent(() => import("@/views/google/store.vue")),
  GoogleVideo: defineAsyncComponent(() => import("@/views/google/video.vue")),
};

if (!isInPWA && !isInAndroidApp) {
  showLoadingToast("loading...");
}
if (id && !isInPWA && !isInAndroidApp) {
  getGoogleTemplatesInfo({ id }).then(async ({ code, data }) => {
    closeToast();
    console.log("data", data);
    if (code === 1) {
      info.value = data;
      template.value = templates[data.type] || null;
      // template.value = templates.GoogleVideo;

      if (!template.value) {
        showFailToast("Invalid template");
      }
    } else {
      showFailToast(data.msg);
    }
  });
} else {
  if (!isInPWA && !isInAndroidApp) {
    showFailToast("Invalid tid");
  }
}
</script>
